export const FEEDBACK_TYPE = {
  NPS: 'NPS',
  CSAT: 'CSAT',
};

export const CSAT_NPS_FEEDBACK_OBJ = {
  orderId: null,
  overall: { rating: null },
  food: [],
  delivery: {},
  deliveryRatings: [],
  valueForMoney: [],
  tempDeliveryRating: null,
  comments: '',
  showShimmer: true,
  templateApiData: {},
  ordering: {},
  submitApiResponse: {},
  showThankyouScreen: false,
  showLoaderAnimation: false,
  showTickAnimation: false,
  nps: {
    orderId: null,
    overall: { rating: null },
    food: [],
    delivery: {},
    deliveryRatings: [],
    valueForMoney: [],
    tempDeliveryRating: null,
    comments: '',
    showShimmer: true,
    templateApiData: {},
    ordering: {},
    submitApiResponse: {},
    showThankyouScreen: false,
    showLoaderAnimation: false,
    showTickAnimation: false
  }
};
